module.exports = __webpack_public_path__ + "static/img/IMG_20170907_184511.1cdfab9d.jpg";